import { Component, OnInit, OnDestroy } from '@angular/core';
import { Tenant } from 'src/app/shared/models/tenant';
import { Form } from 'src/app/shared/models/application/form';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MembersService } from 'src/app/shared/services/members.service';
import { FormService } from 'src/app/shared/services/form.service';
import { Router, ActivatedRoute } from '@angular/router';
import { of, Subscription } from 'rxjs';
import { FormType } from 'src/app/shared/models/application/formType';
import { AppConfigService } from 'src/app/shared/services/app-config.service';

import _ from 'lodash';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-request',
  templateUrl: './application-request.component.html',
  styleUrls: ['./application-request.component.scss'],
  standalone: false
})
export class ApplicationRequestComponent implements OnInit, OnDestroy {
  tenant: Tenant;
  form: Form;
  requestForm: UntypedFormGroup;
  recaptchaSiteKey: string;
  routeSubscription: Subscription;
  formSub: Subscription;
  isSending = false;
  isLoading = true;
  applicationId: string;
  showVerificationCode = false;
  email: string;
  errorMessage: string;
  get showSpinner() {
    return this.isSending || this.isLoading;
  }
  constructor(
    private appConfigService: AppConfigService,
    private formService: FormService,
    private formBuilder: UntypedFormBuilder,
    private membersService: MembersService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.setApplicationForm();
    this.tenant = this.appConfigService.tenant;
    this.recaptchaSiteKey = this.appConfigService.config.recaptchaSiteKey;

    let comp = this;
    this.routeSubscription = this.route.params.subscribe((params) => {
      let formId = params['formId'];
      this.formSub = comp.formService.getFormWithoutQuestionsById(formId).subscribe((form) => {
        if (form) {
          this.isLoading = false;
          if (form.formType == FormType.Application) {
            comp.form = form;
            this.membersService.workspaceLogoUrl.next(form.workspaceLogoUrl);
            this.membersService.workspaceHelpLink.next(form.workspaceHelpLink);
          } else {
            this.router.navigate(['home'], {});
          }
        } else {
          this.router.navigate(['/members/not-found'], { skipLocationChange: true });
        }
      });
    });
  }

  ngOnDestroy() {
    if (this.routeSubscription) this.routeSubscription.unsubscribe();
    if (this.formSub) this.formSub.unsubscribe();
  }

  setApplicationForm() {
    this.requestForm = this.formBuilder.group({
      email: [null, [Validators.required, Validators.email]],
      recaptcha: [null, Validators.required]
    });
  }

  requestApplication() {
    if (this.requestForm?.valid) {
      this.isSending = true;
      this.email = this.requestForm.get('email').value;
      this.membersService
        .requestApplication(this.form.id, this.email)
        .pipe(
          catchError((errorResponse) => {
            if (
              errorResponse.error &&
              errorResponse.status === 400 &&
              errorResponse.error.message
            ) {
              this.errorMessage = errorResponse.error.message;
            } else {
              this.errorMessage = 'Something went wrong! Please try again later..';
            }
            return of(null);
          })
        )
        .subscribe((data) => {
          this.isSending = false;
          this.showVerificationCode = true;
          if (data) {
            this.applicationId = data;
          }
        });
    }
  }
}
